exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper.product-carousel-swiper {\n  height: 80%;\n  width: 100%;\n}\n.swiper.product-carousel-thumbs {\n  height: 20%;\n  box-sizing: border-box;\n  padding: 10px 0;\n}\n.swiper.product-carousel-thumbs img:hover {\n  cursor: pointer;\n}\n.swiper.product-carousel-thumbs .swiper-slide {\n  width: 25%;\n  height: 100%;\n  opacity: 0.4;\n}\n.swiper.product-carousel-thumbs .swiper-slide-active {\n  opacity: 1;\n}\n.swiper .swiper-button-disabled {\n  display: none;\n}", ""]);

// exports
